import { IonButton } from "@ionic/react";
import { ComponentProps } from "react";
import { useIntl } from "react-intl";

import styles from "@components/buttons/RichTextareaMenuButton.module.css";
import IconBase from "@components/text/IconBase";
import Tooltip from "@components/Tooltip";
import { IconName } from "@utils/iconUtils";

type Props = Omit<ComponentProps<typeof IonButton>, "aria-label" | "color" | "fill"> & {
  active?: boolean;
  icon: IconName;
  translationId: string;
};

const RichTextareaMenuButton = ({ active = false, className, icon, translationId, ...buttonProps }: Props) => {
  const intl = useIntl();

  const classNames = [styles.button];
  if (className) {
    classNames.push(className);
  }

  return (
    <Tooltip content={intl.formatMessage({ id: translationId })}>
      {tooltipTriggerProps => (
        // eslint-disable-next-line react/forbid-elements
        <IonButton
          aria-label={intl.formatMessage({ id: translationId })}
          className={classNames.join(" ")}
          color={active ? "gray-200" : "white"}
          fill={active ? "solid" : "clear"}
          mode="md"
          {...buttonProps}
          {...tooltipTriggerProps}
        >
          <IconBase color={active ? "gray" : "gray-500"} icon={icon} size="small" slot="icon-only" />
        </IonButton>
      )}
    </Tooltip>
  );
};

export default RichTextareaMenuButton;
